jQuery(document).ready(function ($) {

	// image slider block
	var image_slider_swiper = new Swiper('.block-image-slider-right.swiper-container', {
		slidesPerView: 'auto',
		grabCursor: true,
		loop: true,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		updateOnWindowResize: true,
	});

	// customer quote block
	var customer_quote_swiper = new Swiper('.customer-quote-content.swiper-container', {
		slidesPerView: 1,
		grabCursor: true,
		autoplay: {
			delay: 5000,
		},
		effect: 'fade',
		fadeEffect: {
		  crossFade: true
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		loop: true,
		updateOnWindowResize: true,
	});

	// Video slider
	var video_slider_swiper = new Swiper(".block-video-slider", {
		slidesPerView: 'auto',
		grabCursor: true,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		loop: true,
		updateOnWindowResize: true,
    });

});
